import Vue from "vue";
import App from "@/App.vue";
import router from "@/routers";
import store from "@/stores";
import i18n from "@/i18n";
import Cookies from "js-cookie";
// 🛡️ Router Middleware
import { setupRouterMiddleware } from "@/middleware";

// 🧩 Plugins
import VueRouter from "vue-router";
import VueAxios from "vue-axios";
import axiosInstance from "@/api/axios";
import VModal from "vue-js-modal";
import Notifications from "vue-notification";
import velocity from "velocity-animate";
import SmartTable from "vuejs-smart-table";
import VSwipe from "vswipe";
import ZoomHover from "vue-zoom-on-hover";
import Vue2Filters from "vue2-filters";
import vSelect from "vue-select";
import rate from "vue-rate";
import "vue-rate/dist/vue-rate.css";

// 🕒 Moment.js (time formatting)
import moment from "moment";
import "moment/locale/fr";
import "moment/locale/ar";

import "@/filters";
// Configure moment to use Western Arabic numerals for Arabic
moment.updateLocale('fr', {
  preparse: function (string) {
    return string;
  },
  postformat: function (string) {
    return string;
  }
});

// 🧠 Components
// import LocaleSwitcher from "@/components/templates/LocaleSwitcher.vue";

// Mixins
import imageErrorHandler from "@/mixins/imageErrorHandler.js";
Vue.mixin(imageErrorHandler);

Vue.config.productionTip=false;

// Attach axios globally
Vue.prototype.$axios=axiosInstance;

// ==========================
// 🧩 Plugin Registration
// ==========================
Vue.use(VueRouter);
Vue.use(VueAxios, axiosInstance);
Vue.use(VModal, { componentName: "modal", dialog: true });
Vue.use(Notifications, { velocity });
Vue.use(SmartTable);
Vue.use(VSwipe);
Vue.use(ZoomHover);
Vue.use(Vue2Filters);
Vue.use(rate);

// ==========================
// 🌍 Global Components
// ==========================
Vue.component("v-select", vSelect.VueSelect||vSelect);

// ==========================
// 🚀 Initial Setup
// ==========================
const savedLang=Cookies.get('lang');
if (savedLang) {
  i18n.locale=savedLang;
  document.documentElement.setAttribute('dir', savedLang==='ar'? 'rtl':'ltr');
  document.documentElement.setAttribute('lang', savedLang);
  moment.locale(savedLang);
}

// ==========================
// 🛡️ Setup Router Middleware
// ==========================
setupRouterMiddleware(router);
// ==========================
// 🚀 App Initialization
// ==========================
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");